/* Lighthoof Project Planner (Panel Calculator v2), Oct 2026.
   Panels count as 6' x 12'. Cut pieces lose 5" per cut, nothing is cut narrower than 3', and leftover strips
   are rebuilt from offcuts tied together (Kelly's rule, Oct 22 2026). Round pens and angled areas reuse
   offcuts the same way and label pieces cut from one panel with the same letter. */
(function () {
  'use strict';

  var root = document.getElementById('lhp-app');
  if (!root) return;

  // ---------- Data ----------
  var PRICE_BASE = 219;
  var FABRIC_DISCOUNT = 0.10;
  var PANEL_W = 6, PANEL_L = 12, CUT_LOSS = 5 / 12, MIN_CUT = 3;
  var TIERS = [
    { min: 50, discount: 0.20, label: '20% volume price (50+)' },
    { min: 20, discount: 0.10, label: '10% volume price (20 to 49)' },
    { min: 10, discount: 0.05, label: '5% volume price (10 to 19)' },
    { min: 1, discount: 0, label: 'Regular price' }
  ];
  var FABRIC = [
    { name: "4' x 50'", area: 200, price: 84.98, variant: 0 },
    { name: "8' x 50'", area: 400, price: 152.98, variant: 0 },
    { name: "8' x 100'", area: 800, price: 267.98, variant: 0 }
  ];
  var BUNDLES = [
    { panels: 2, price: 499, compare: 537, handle: 'bundle-of-2-lighthoof-panels-and-geotextile-fabric', variant: 0 },
    { panels: 4, price: 975, compare: 1056, handle: 'bundle-of-4-lighthoof-panels-and-free-fabric', variant: 0 },
    { panels: 10, price: 2299, compare: 2510, handle: '10-panels-fabric', variant: 0 },
    { panels: 24, price: 5249, compare: 6076, handle: 'bundle-of-24-lighthoof-panels-and-geotextile-fabric', variant: 0 },
    { panels: 50, price: 9999, compare: 12550, handle: 'bundle-of-24-lighthoof-panels-and-geotextile-fabric-1', variant: 0 }
  ];
  var PANEL_VARIANT = 0, PANEL_URL = '/products/lighthoof-equine-mud-management-panel';

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('lhp-config').textContent) || {}; } catch (e) {}
  if (cfg.panel) {
    if (cfg.panel.price > 0) PRICE_BASE = cfg.panel.price / 100;
    if (cfg.panel.variant) PANEL_VARIANT = cfg.panel.variant;
    if (cfg.panel.url) PANEL_URL = cfg.panel.url;
  }
  if (cfg.fabric && cfg.fabric.length === FABRIC.length) {
    cfg.fabric.forEach(function (f, i) { if (f.price > 0) FABRIC[i].price = f.price / 100; FABRIC[i].variant = f.variant || 0; });
  }
  BUNDLES.forEach(function (b) {
    var live = cfg.bundles && cfg.bundles[b.handle];
    if (live) {
      if (live.price > 0) b.price = live.price / 100;
      if (live.compare > 0) b.compare = live.compare / 100;
      b.variant = live.variant || 0;
    }
    b.url = '/products/' + b.handle;
  });
  // Wholesale (B2B) customers: the live prices above are already their wholesale prices, the same at any
  // quantity, so no volume tiers, no fabric discount and no bundles.
  var B2B = !!cfg.b2b;
  if (B2B) { TIERS = [{ min: 1, discount: 0, label: 'Your wholesale price' }]; FABRIC_DISCOUNT = 0; }
  var PHONE = cfg.phone || '800-279-4716';
  var PHONE_TEL = '+1' + PHONE.replace(/\D/g, '').replace(/^1/, '');
  // Compact mode (homepage, product pages): measurements, panel count, price, a small drawing,
  // and a link that opens the full planner page with the same measurements filled in.
  var COMPACT = !!cfg.compact;
  var FULL_URL = cfg.fullUrl || '/pages/panel-calculator';
  var HELP_URL = COMPACT ? FULL_URL + '#lhp-help' : '#lhp-help';
  var PLACEMENT = cfg.standalone ? 'calculator_page' : (cfg.placement === 'index' ? 'homepage' : (cfg.placement || 'embedded'));

  // ---------- Tracking (same events as the original calculator) ----------
  // Every event carries calculator_placement so homepage, product page and calculator page use can be told apart.
  function track(event, data) {
    window.dataLayer = window.dataLayer || [];
    data = data || {};
    data.calculator_placement = PLACEMENT;
    var payload = { event: event };
    for (var k in data) payload[k] = data[k];
    window.dataLayer.push(payload);
    if (typeof gtag === 'function') gtag('event', event, data || {});
    if (typeof fbq === 'function') {
      var name = event.replace(/(^|_)(\w)/g, function (m, a, c) { return c.toUpperCase(); });
      fbq('trackCustom', name, data || {});
    }
  }
  if (cfg.standalone) track('calculator_page_visit', {});

  // ---------- Helpers ----------
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function num(v) { var n = parseFloat(v); return isFinite(n) && n > 0 ? Math.min(n, 2000) : 0; }
  function money(x) {
    x = Math.round(x * 100) / 100;
    var cents = Math.abs(x % 1) > 0.001;
    return '$' + x.toLocaleString('en-US', { minimumFractionDigits: cents ? 2 : 0, maximumFractionDigits: 2 });
  }
  function fmt(n, d) { var p = Math.pow(10, d || 0); return (Math.round(n * p) / p).toLocaleString('en-US'); }
  function ft(n) { return (n % 1 ? n.toFixed(1) : n) + "'"; }
  function unitPrice(qty) {
    for (var i = 0; i < TIERS.length; i++) if (qty >= TIERS[i].min) return { price: Math.round(PRICE_BASE * (1 - TIERS[i].discount) * 100) / 100, tier: TIERS[i] };
    return { price: PRICE_BASE, tier: TIERS[TIERS.length - 1] };
  }

  // Leftover strips are rebuilt from pieces of whole 6' x 12' panels: a panel is cut into strips of the needed
  // widths (5" lost per cut), and strip pieces are tied end to end. Finds the fewest panels for both strips.
  function stripPanels(A, a, B, b) {
    if (!(A > 0.01) && !(B > 0.01)) return 0;
    var pats = [];
    [[PANEL_W, PANEL_L], [PANEL_L, PANEL_W]].forEach(function (d) {
      for (var i = 0; i * (a || 99) <= d[0] + 0.01; i++) for (var j = 0; j * (b || 99) <= d[0] + 0.01; j++) {
        if (!i && !j) continue;
        if ((i && !(A > 0.01)) || (j && !(B > 0.01))) continue;
        if (i * a + j * b + (i + j - 1) * CUT_LOSS <= d[0] + 1e-9) pats.push([i * d[1], j * d[1]]);
      }
    });
    function need(v, s) { return v > 0.01 ? (s > 0 ? Math.ceil(v / s - 1e-9) : Infinity) : 0; }
    var best = Infinity;
    pats.forEach(function (p) {
      pats.forEach(function (q) {
        var xmax = Math.max(need(A, p[0]) === Infinity ? 0 : need(A, p[0]), need(B, p[1]) === Infinity ? 0 : need(B, p[1]));
        for (var x = 0; x <= xmax; x++) {
          var t = x + Math.max(need(A - x * p[0], q[0]), need(B - x * p[1], q[1]));
          if (t < best) best = t;
        }
      });
    });
    return best;
  }
  function calcLayout(areaW, areaL) {
    var options = [];
    [[PANEL_W, PANEL_L], [PANEL_L, PANEL_W]].forEach(function (o) {
      var pw = o[0], pl = o[1];
      var fullW = Math.floor(areaW / pw + 1e-9), remainW = areaW - fullW * pw, actW = areaW;
      if (remainW < 0.01) remainW = 0;
      if (remainW > 0 && remainW < MIN_CUT) { actW = fullW * pw + MIN_CUT; remainW = MIN_CUT; }
      var fullL = Math.floor(areaL / pl + 1e-9), remainL = areaL - fullL * pl, actL = areaL;
      if (remainL < 0.01) remainL = 0;
      if (remainL > 0 && remainL < MIN_CUT) { actL = fullL * pl + MIN_CUT; remainL = MIN_CUT; }
      var fullPanels = fullW * fullL;
      // Right strip: remainW wide, fullL * pl long. Bottom strip: remainL wide, fullW * pw long.
      // The corner (remainW x remainL) joins whichever strip costs fewer panels.
      var A = remainW ? fullL * pl : 0, B = remainL ? fullW * pw : 0, addl;
      if (remainW && remainL) addl = Math.min(stripPanels(A + remainL, remainW, B, remainL), stripPanels(A, remainW, B + remainW, remainL));
      else addl = stripPanels(A, remainW, B, remainL);
      var cuts = (remainW ? fullL : 0) + (remainL ? fullW : 0) + (remainW && remainL ? 1 : 0);
      options.push({ pw: pw, pl: pl, fullW: fullW, fullL: fullL, fullPanels: fullPanels, cuts: cuts, addl: addl, total: fullPanels + addl, remainW: remainW, remainL: remainL, actW: actW, actL: actL });
    });
    options.sort(function (a, b) { return a.total - b.total || a.cuts - b.cuts; });
    return options[0];
  }

  // Cheapest way to cover a fabric area (sq ft) with the three roll sizes. Original logic.
  function fabricFor(fabricArea) {
    if (!(fabricArea > 0)) return null;
    var opts = [], i, nb;
    for (i = 0; i < FABRIC.length; i++) {
      var n = Math.ceil(fabricArea / FABRIC[i].area);
      opts.push({ items: [[i, n]], total: n * FABRIC[i].price });
    }
    var big = FABRIC[2], med = FABRIC[1];
    for (nb = 0; nb <= 40; nb++) {
      var rem = fabricArea - nb * big.area;
      if (rem <= 0 && nb > 0) { opts.push({ items: [[2, nb]], total: nb * big.price }); break; }
      if (rem > 0) {
        var nm = Math.ceil(rem / med.area);
        var it = []; if (nb) it.push([2, nb]); if (nm) it.push([1, nm]);
        opts.push({ items: it, total: nb * big.price + nm * med.price });
      }
    }
    opts.sort(function (a, b) { return a.total - b.total; });
    var best = opts[0];
    best.desc = best.items.map(function (p) { return (p[1] > 1 ? p[1] + ' rolls, ' : '1 roll, ') + FABRIC[p[0]].name; }).join(' + ');
    best.discounted = Math.round(best.total * (1 - FABRIC_DISCOUNT) * 100) / 100;
    return best;
  }

  // ---------- State ----------
  var USES = [
    ['stall', 'Stall'], ['gate', 'Gate area'], ['shelter', 'Run-in shelter'], ['runs', 'Stall runs'],
    ['drylot', 'Paddock or drylot'], ['feeder', 'Hay or water area'], ['track', 'Track or path']
  ];
  var SHAPES = [
    ['rect', 'Rectangle', '<rect x="2" y="3" width="22" height="12" rx="1"/>'],
    ['sections', 'Sections', '<rect x="2" y="3" width="10" height="12" rx="1"/><rect x="15" y="6" width="9" height="9" rx="1"/>'],
    ['ring', 'Round pen', '<circle cx="13" cy="9" r="8"/>'],
    ['trap', 'Angled', '<path d="M3 16h20V3L3 9z"/>']
  ];
  var S = {
    mode: 'rect', w: '', l: '', secs: [{ w: '', l: '' }, { w: '', l: '' }],
    l1: '', w1: '', l2: '', w2: '', D: '', P: '', tb: '', th1: '', th2: '',
    use: '', fabric: true, deep: false, name: '', sent: false
  };
  var FIELDS = ['w', 'l', 'l1', 'w1', 'l2', 'w2', 'D', 'P', 'tb', 'th1', 'th2'];

  // A plan can be restored from the link in the emailed plan: #plan=<encoded state>
  function encodeState() {
    var o = { m: S.mode, u: S.use, f: S.fabric ? 1 : 0, d: S.deep ? 1 : 0, n: S.name };
    FIELDS.forEach(function (k) { if (S[k] !== '') o[k] = S[k]; });
    if (S.mode === 'sections') o.s = S.secs.map(function (s) { return [s.w, s.l]; });
    try { return btoa(unescape(encodeURIComponent(JSON.stringify(o)))); } catch (e) { return ''; }
  }
  function restoreState() {
    var m = /[#&]plan=([^&]+)/.exec(location.hash);
    if (!m) return;
    try {
      var o = JSON.parse(decodeURIComponent(escape(atob(decodeURIComponent(m[1])))));
      if (o.m) S.mode = o.m;
      // The L-shape option was replaced by sections; old saved L-shape plans open as two sections.
      if (S.mode === 'L') { S.mode = 'sections'; o.s = [[o.l1, o.w1], [o.w2, o.l2]]; }
      S.use = o.u || ''; S.fabric = o.f !== 0; S.deep = o.d === 1; S.name = o.n || '';
      FIELDS.forEach(function (k) { if (o[k] != null) S[k] = String(o[k]); });
      if (o.s && o.s.length) S.secs = o.s.slice(0, 4).map(function (p) { return { w: String(p[0] || ''), l: String(p[1] || '') }; });
    } catch (e) {}
  }
  restoreState();

  // ---------- Plan math ----------
  function plan() {
    var P = { valid: false, n: 0, area: 0, fabricArea: 0, pieces: [], polys: [], circles: [], labels: [], bw: 0, bh: 0, dims: '', note: '', trimNote: '' };
    function addRect(x, y, wFt, lFt, label) {
      var r = calcLayout(wFt, lFt);
      P.pieces.push({ x: x, y: y, r: r, w: wFt, l: lFt });
      P.n += r.total; P.area += wFt * lFt; P.fabricArea += (r.actW + 2) * (r.actL + 2);
      if (label) P.labels.push({ x: x + r.actW / 2, y: y, dy: -22, t: label });
      return r;
    }
    var W = num(S.w), L = num(S.l);
    if (S.mode === 'rect') {
      if (W && L) {
        var r = addRect(0, 0, W, L);
        P.labels.push({ x: r.actW / 2, y: 0, dy: -22, t: ft(W) + ' wide' });
        P.labels.push({ x: 0, y: r.actL / 2, dx: -24, t: ft(L) + ' long', v: true });
        P.bw = r.actW; P.bh = r.actL; P.valid = true; P.dims = W + "' x " + L + "'";
        if (r.actW > W || r.actL > L) P.note = "We extended the layout to " + ft(r.actW) + ' x ' + ft(r.actL) + " so every cut piece is at least 3' wide.";
      }
    } else if (S.mode === 'sections') {
      var cx = 0, used = 0;
      S.secs.forEach(function (s, i) {
        var sw = num(s.w), sl = num(s.l);
        if (!(sw && sl)) return;
        var rr = addRect(cx, 0, sw, sl, 'ABCD'.charAt(i) + ': ' + sw + ' x ' + sl + ' ft');
        P.bh = Math.max(P.bh, rr.actL); cx += rr.actW + 6; used++;
      });
      P.bw = Math.max(cx - 6, 0); P.valid = used > 0; P.dims = used + ' section' + (used > 1 ? 's' : '');
    } else if (S.mode === 'L') {
      var l1 = num(S.l1), w1 = num(S.w1), l2 = num(S.l2), w2 = num(S.w2);
      if (l1 && w1 && l2 && w2) {
        var r1 = addRect(0, 0, l1, w1);
        var r2 = addRect(0, r1.actL, w2, l2);
        P.labels.push({ x: r1.actW / 2, y: 0, dy: -22, t: 'Leg 1: ' + ft(l1) });
        P.labels.push({ x: r1.actW, y: r1.actL / 2, dx: 8, t: ft(w1), v: true });
        P.labels.push({ x: 0, y: r1.actL + r2.actL / 2, dx: -24, t: 'Leg 2: ' + ft(l2), v: true });
        P.labels.push({ x: r2.actW / 2, y: r1.actL + r2.actL, dy: 6, t: ft(w2) });
        P.bw = Math.max(r1.actW, r2.actW); P.bh = r1.actL + r2.actL; P.valid = true; P.dims = 'L-shape';
      }
    } else if (S.mode === 'trap') {
      var B = num(S.tb), h1 = num(S.th1), h2 = num(S.th2);
      if (B && h1 && h2) {
        var hAt = function (x) { return h1 + (h2 - h1) * Math.min(Math.max(x, 0), B) / B; };
        // Columns run up from the straight side. Panels wholly under the angled line are used whole. The top
        // piece of each column follows the angle, so the cut-off part of one top piece, turned around, can be
        // the top piece of another column, as long as the reused part is at least 3' (5" lost per cut).
        var lay = function (pw, ph) {
          var cells = [], pieces = [], narrow = { cells: 0, w: 0 }, Htop = 0;
          for (var x = 0; x < B - 0.01; x += pw) {
            var w = Math.min(pw, B - x), lo = Math.min(hAt(x), hAt(x + w)), hi = Math.max(hAt(x), hAt(x + w));
            for (var j = 0; j * ph < hi - 0.01; j++) {
              var base = j * ph, l = Math.min(Math.max(lo - base, 0), ph), h = Math.min(Math.max(hi - base, 0), ph);
              var cell = { x: x, j: j, w: w, h: ph, lo: l, hi: h };
              if (l >= ph - 0.01) cell.full = true;
              else {
                // Nothing narrower than 3' gets cut on its own.
                if (cell.hi < MIN_CUT) cell.hi = MIN_CUT;
                cell.lo = Math.min(cell.lo, cell.hi);
                cell.full = cell.hi >= ph - 0.01;
              }
              Htop = Math.max(Htop, base + (cell.full ? ph : cell.hi));
              cells.push(cell);
              if (w < pw - 0.01) { narrow.cells++; narrow.w = w; }
              else if (!cell.full) pieces.push(cell);
            }
          }
          // Pair top pieces: piece B turned 180 degrees fits in what's left of A's panel when both ends clear.
          var pairs = [], used = {};
          pieces.forEach(function (c, i) { c.i = i; });
          pieces.slice().sort(function (a, b) { return b.hi - a.hi; }).forEach(function (A) {
            if (used[A.i]) return;
            var best = null, bestLeft = 1e9;
            pieces.forEach(function (Bp) {
              if (Bp === A || used[Bp.i]) return;
              var need = Math.max(A.lo + Bp.hi, A.hi + Bp.lo) + CUT_LOSS;
              var reuse = ph - A.lo;            // thickest part of A's offcut
              if (need <= ph && reuse >= MIN_CUT && ph - need < bestLeft) { best = Bp; bestLeft = ph - need; }
            });
            if (best) { used[A.i] = used[best.i] = 1; pairs.push([A, best]); }
          });
          var full = cells.filter(function (c) { return c.full && c.w >= pw - 0.01; }).length;
          var n = full + pieces.length - pairs.length;
          if (narrow.cells) {
            // A column narrower than a panel is cut as strips; one panel gives several strips.
            var strips = Math.max(1, Math.floor((pw + CUT_LOSS) / (Math.max(narrow.w, MIN_CUT) + CUT_LOSS)));
            n += Math.ceil(narrow.cells / strips);
          }
          return { cells: cells, pairs: pairs, n: n, pw: pw, ph: ph, Htop: Htop };
        };
        var pl = [lay(PANEL_L, PANEL_W), lay(PANEL_W, PANEL_L)].sort(function (a, b) { return a.n - b.n; })[0];
        var Hb = Math.max(h1, h2, pl.Htop), tagN2 = 0;
        pl.pairs.forEach(function (pr) {
          var tag = tagN2 < 26 ? String.fromCharCode(65 + tagN2) : String.fromCharCode(64 + Math.floor(tagN2 / 26)) + String.fromCharCode(65 + tagN2 % 26);
          pr[0].tag = pr[1].tag = tag; tagN2++;
        });
        pl.cells.forEach(function (c) {
          var hh = c.full ? pl.ph : c.hi;
          P.pieces.push({ cell: { x: c.x, y: Hb - c.j * pl.ph - hh, w: c.w, h: hh, cut: !c.full || c.w < pl.pw - 0.01, tag: c.tag } });
        });
        P.shared = pl.pairs.length;
        P.n = pl.n; P.area = B * (h1 + h2) / 2; P.fabricArea = (B + 2) * ((h1 + h2) / 2 + 2);
        P.diag = Math.round(Math.sqrt(B * B + (h2 - h1) * (h2 - h1)));
        P.bw = B; P.bh = Hb;
        P.polys.push([[0, Hb], [B, Hb], [B, Hb - h2], [0, Hb - h1]]);
        P.labels.push({ x: B / 2, y: Hb, dy: 6, t: 'Straight side: ' + ft(B) });
        P.labels.push({ x: 0, y: Hb - h1 / 2, dx: -24, t: ft(h1), v: true });
        P.labels.push({ x: P.bw, y: Hb - h2 / 2, dx: 8, t: ft(h2), v: true });
        P.labels.push({ x: B / 2, y: Hb - (h1 + h2) / 2, dy: -8, t: 'Angled side: about ' + P.diag + "'", pill: true });
        P.valid = true; P.dims = 'angled area, ' + B + "' straight side";
        P.trimNote = 'Panels along the angled side get trimmed to the line.' + (P.shared ? ' Top pieces with the same letter are cut from one panel: the cut-off part of one is turned around to fill another.' : '');
      }
    } else if (S.mode === 'ring') {
      var D = num(S.D), BUF = num(S.P);
      if (D) {
        var R = D / 2 + BUF, best = null, R2 = (R - 0.25) * (R - 0.25), SAMP = 20;
        // Measure one grid cell against the circle: how much of the panel the piece uses, the size of the piece
        // (rounded up), and the size of the offcut (less 5" for the cut).
        var measure = function (x, y, pw, ph) {
          var hit = 0, si = 0, sj = 0, n0 = [1e9, -1e9, 1e9, -1e9], n1 = [1e9, -1e9, 1e9, -1e9];
          for (var i = 0; i < SAMP; i++) for (var j = 0; j < SAMP; j++) {
            var sx = x + (i + 0.5) * pw / SAMP, sy = y + (j + 0.5) * ph / SAMP, b = sx * sx + sy * sy < R2 ? n0 : n1;
            if (b === n0) { hit++; si += i; sj += j; }
            b[0] = Math.min(b[0], i); b[1] = Math.max(b[1], i); b[2] = Math.min(b[2], j); b[3] = Math.max(b[3], j);
          }
          if (!hit) return null;
          var tot = SAMP * SAMP, f = hit / tot;
          if (hit === tot) return { full: true, f: 1 };
          return {
            full: false, f: f, cx: (si / hit + 0.5) * pw / SAMP, cy: (sj / hit + 0.5) * ph / SAMP,
            ex: Math.min(pw, (n0[1] - n0[0] + 2) * pw / SAMP), ey: Math.min(ph, (n0[3] - n0[2] + 2) * ph / SAMP),
            ox: (n1[1] - n1[0] + 1) * pw / SAMP - CUT_LOSS, oy: (n1[3] - n1[2] + 1) * ph / SAMP - CUT_LOSS,
            off: 1 - f - 0.04
          };
        };
        var layout = function (pw, ph, fx, fy) {
          var cells = [], edge = [];
          for (var y = -R - fy * ph; y < R; y += ph) {
            for (var x = -R - fx * pw; x < R; x += pw) {
              var cxp = Math.max(x, Math.min(0, x + pw)), cyp = Math.max(y, Math.min(0, y + ph));
              if (cxp * cxp + cyp * cyp >= R2) continue;
              var m = measure(x, y, pw, ph);
              if (!m) continue;
              var cell = { x: x + R, y: y + R, w: pw, h: ph, cut: !m.full, m: m };
              cells.push(cell); if (!m.full) edge.push(cell);
            }
          }
          // An edge piece can come out of another edge panel's offcut when it fits in the offcut's
          // footprint and area. Smallest pieces look for a home first, in the snuggest offcut that fits.
          var pairs = [], taken = {};
          edge.forEach(function (c, i) { c.i = i; });
          edge.slice().sort(function (a, b) { return a.m.f - b.m.f; }).forEach(function (g) {
            if (taken[g.i]) return;
            var home = null;
            edge.forEach(function (h) {
              if (h === g || taken[h.i]) return;
              var fits = (g.m.ex <= h.m.ox && g.m.ey <= h.m.oy) || (g.m.ey <= h.m.ox && g.m.ex <= h.m.oy && pw === ph);
              if (fits && g.m.f <= h.m.off && (!home || h.m.off < home.m.off)) home = h;
            });
            if (home) { taken[g.i] = taken[home.i] = 1; pairs.push([home, g]); }
          });
          return { cells: cells, pairs: pairs, n: cells.length - pairs.length };
        };
        [[PANEL_L, PANEL_W], [PANEL_W, PANEL_L]].forEach(function (o) {
          for (var fx = 0; fx < 1; fx += 0.125) for (var fy = 0; fy < 1; fy += 0.125) {
            var t = layout(o[0], o[1], fx, fy);
            if (!best || t.n < best.n) best = t;
          }
        });
        best.bins = best.pairs.map(function (p) { return { items: p }; });
        best.saved = best.pairs.length;
        // Pieces cut from the same panel get the same letter.
        var tagN = 0;
        best.bins.forEach(function (b) {
          if (b.items.length < 2) return;
          var tag = tagN < 26 ? String.fromCharCode(65 + tagN) : String.fromCharCode(64 + Math.floor(tagN / 26)) + String.fromCharCode(65 + tagN % 26);
          b.items.forEach(function (e) { e.tag = tag; });
          tagN++;
        });
        P.shared = best.saved;
        P.n = best.n;
        best = best.cells;
        P.area = Math.PI * R * R;
        P.fabricArea = Math.pow(2 * R + 2, 2) * 0.85;
        P.circles.push({ R: R, D: D, B: BUF, cells: best });
        P.bw = P.bh = 2 * R; P.valid = true;
        P.labels.push({ x: R, y: 0, dy: -22, t: (BUF ? 'Outside edge: ' : 'Round pen: ') + ft(2 * R) + ' across' });
        P.dims = D + "' round pen" + (BUF ? ' + ' + BUF + "' buffer" : '');
        P.trimNote = 'Panels are trimmed to the circle along the edge.' + (tagN ? ' Edge pieces with the same letter are cut from one panel, so the offcut from one side of the pen fills a spot on another.' : '');
      }
    }
    return P;
  }

  function pricing(n, fabricArea) {
    var up = unitPrice(n);
    var fab = S.fabric ? fabricFor(fabricArea) : null;
    var loose = n * up.price + (fab ? fab.discounted : 0);
    var regular = n * PRICE_BASE + (fab ? fab.total : 0);
    var best = { kind: 'loose', total: loose, lines: [], cart: [] };
    best.lines.push({ name: 'Lighthoof panels', detail: n + ' x ' + money(up.price) + ', ' + up.tier.label.toLowerCase(), amt: n * up.price });
    best.cart.push([PANEL_VARIANT, n]);
    if (fab) {
      best.lines.push({ name: 'Geotextile fabric', detail: fab.desc + (B2B ? '' : ', 10% off with panels'), amt: fab.discounted });
      fab.items.forEach(function (p) { best.cart.push([FABRIC[p[0]].variant, p[1]]); });
    }
    if (fab && !B2B) {
      BUNDLES.forEach(function (b) {
        var extra = n - b.panels;
        // A bundle is offered only when it covers the whole order (up to 2 panels bigger than needed).
        // Anything else is priced as loose panels, so the quote never mixes a bundle with loose panels.
        if (extra > 0 || extra < -2 || !b.variant) return;
        var opt = { kind: 'bundle', bundle: b, lines: [], cart: [[b.variant, 1]] };
        var total = b.price;
        opt.lines.push({ name: b.panels + '-panel bundle with fabric', detail: b.panels + ' panels plus the fabric to go under them' + (extra < 0 ? ' (' + (-extra) + ' more panel' + (extra < -1 ? 's' : '') + ' than you need)' : ''), amt: b.price });
        opt.total = total;
        if (total < best.total - 0.5) best = opt;
      });
    }
    best.loose = loose; best.regular = regular; best.unit = up; best.fab = fab;
    return best;
  }

  // ---------- Rendering ----------
  function shapeButtons() {
    return SHAPES.map(function (s) {
      var on = S.mode === s[0];
      return '<button type="button" class="lhp-shape' + (on ? ' is-on' : '') + '" data-mode="' + s[0] + '" aria-pressed="' + on + '">' +
        '<svg width="26" height="18" viewBox="0 0 26 18" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">' + s[2] + '</svg>' + s[1] + '</button>';
    }).join('');
  }
  function input(key, label, val, extra) {
    return '<label class="lhp-field' + (extra || '') + '"><span>' + label + '</span><input type="number" min="1" step="any" inputmode="decimal" data-k="' + key + '" value="' + esc(val) + '"></label>';
  }
  function shapeInputs() {
    var h = '';
    if (S.mode === 'rect') {
      h += '<div class="lhp-row">' + input('w', 'Width (ft)', S.w) + '<span class="lhp-x" aria-hidden="true">×</span>' + input('l', 'Length (ft)', S.l) + '</div>';
      h += '<p class="lhp-callout"><strong>Not a rectangular area?</strong> Lighthoof stretches and trims to fit odd shapes. Calculate it based on the closest rectangular dimensions, or <a href="' + HELP_URL + '">send us a sketch or photos</a> for help planning an unrectangular area.</p>';
    } else if (S.mode === 'sections') {
      h += '<p class="lhp-help">Split your area into rectangles, like a run along the barn plus the gate apron. For an L-shape, enter it as two rectangles. Up to four sections.</p>';
      S.secs.forEach(function (s, i) {
        var L = 'ABCD'.charAt(i);
        h += '<div class="lhp-row lhp-sec"><span class="lhp-letter">' + L + '</span>' + input('sw' + i, 'Width (ft)', s.w) + '<span class="lhp-x" aria-hidden="true">×</span>' + input('sl' + i, 'Length (ft)', s.l) +
          (S.secs.length > 1 ? '<button type="button" class="lhp-remove" data-remove="' + i + '" aria-label="Remove section ' + L + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' : '') + '</div>';
      });
      if (S.secs.length < 4) h += '<button type="button" class="lhp-add" data-add="1">+ Add a section</button>';
    } else if (S.mode === 'L') {
      h += '<p class="lhp-help">Measure the long leg end to end. Measure the second leg from the inside corner out.</p>';
      h += '<div class="lhp-row">' + input('l1', 'Leg 1 length (ft)', S.l1) + input('w1', 'Leg 1 width (ft)', S.w1) + '</div>';
      h += '<div class="lhp-row">' + input('l2', 'Leg 2 length (ft)', S.l2) + input('w2', 'Leg 2 width (ft)', S.w2) + '</div>';
    } else if (S.mode === 'trap') {
      h += '<p class="lhp-help">For an area with one straight side (like along a barn or fence), two short sides of different lengths, and an angled side across from it. Measure the short sides straight out from the straight side.</p>';
      h += '<div class="lhp-row">' + input('tb', 'Straight side (ft)', S.tb) + '</div>';
      h += '<div class="lhp-row">' + input('th1', 'Short side 1 (ft)', S.th1) + input('th2', 'Short side 2 (ft)', S.th2) + '</div>';
      h += '<p class="lhp-callout" data-slot="diag" hidden></p>';
    } else if (S.mode === 'ring') {
      h += '<p class="lhp-help">Covers the whole round pen, with panels trimmed to the circle. Add a buffer if you want footing to extend past the pen.</p>';
      h += '<div class="lhp-row">' + input('D', 'Round pen diameter (ft)', S.D) + input('P', 'Buffer outside the pen (ft, optional)', S.P) + '</div>';
    }
    return h;
  }
  function controlsHTML() {
    if (COMPACT) return '' +
      '<div class="lhp-card">' +
        '<div class="lhp-step"><div class="lhp-step__head">Pick a shape and enter your measurements</div>' +
          '<div class="lhp-shapes" role="group" aria-label="Shape of your area">' + shapeButtons() + '</div>' +
          '<div data-slot="shape">' + shapeInputs() + '</div>' +
        '</div>' +
        '<label class="lhp-check"><input type="checkbox" data-fabric="1"' + (S.fabric ? ' checked' : '') + '><span><strong>Include geotextile fabric</strong><small>' + (B2B ? 'Goes under the panels.' : 'Goes under the panels. 10% off with panels, and unlocks bundle pricing.') + '</small></span></label>' +
        '<ul class="lhp-trust lhp-trust--compact">' +
          '<li>In stock. Ships in 2 to 3 business days.</li>' +
          '<li>Free shipping in the continental US.</li>' +
          '<li>Real people answer at <a href="tel:' + PHONE_TEL + '">' + esc(PHONE) + '</a>.</li>' +
        '</ul>' +
      '</div>';
    return '' +
      '<div class="lhp-card">' +
        '<div class="lhp-step"><div class="lhp-step__head"><span class="lhp-num">1</span>Enter your measurements</div>' +
          '<div class="lhp-shapes" role="group" aria-label="Shape of your area">' + shapeButtons() + '</div>' +
          '<div data-slot="shape">' + shapeInputs() + '</div>' +
        '</div>' +
        '<div class="lhp-step"><div class="lhp-step__head"><span class="lhp-num">2</span>A couple of choices</div>' +
          '<label class="lhp-check"><input type="checkbox" data-fabric="1"' + (S.fabric ? ' checked' : '') + '><span><strong>Include geotextile fabric</strong><small>' + (B2B ? 'Goes under the panels.' : 'Goes under the panels. 10% off with panels, and unlocks bundle pricing.') + '</small></span></label>' +
          '<div class="lhp-sublabel">Gravel use</div>' +
          '<div class="lhp-gravel">' +
            '<button type="button" class="lhp-opt-btn' + (!S.deep ? ' is-on' : '') + '" data-deep="0" aria-pressed="' + !S.deep + '"><strong>Standard</strong><small>1.5 cu yd per panel</small></button>' +
            '<button type="button" class="lhp-opt-btn' + (S.deep ? ' is-on' : '') + '" data-deep="1" aria-pressed="' + S.deep + '"><strong>Thicker top coverage</strong><small>2 cu yd per panel</small></button>' +
          '</div>' +
        '</div>' +
        '<div class="lhp-step"><div class="lhp-step__head"><span class="lhp-num">3</span>Name your project</div>' +
          '<label class="lhp-field lhp-field--full lhp-field--flush"><span>Shows at the top of your plan</span><input type="text" maxlength="60" data-k="name" value="' + esc(S.name) + '" placeholder="Gate by the barn"></label>' +
        '</div>' +
      '</div>' +
      '<ul class="lhp-trust">' +
        '<li>In stock and ready to go. Ships in 2 to 3 business days.</li>' +
        '<li>Free shipping in the continental US.</li>' +
        '<li>Real people answer at <a href="tel:' + PHONE_TEL + '">' + esc(PHONE) + '</a>.</li>' +
      '</ul>';
  }

  function diagramHTML(P) {
    if (P.n > 400) return '<div class="lhp-big"><strong>That\'s a big project!</strong><p>Too many panels to draw here. Call or text ' + esc(PHONE) + ' and we\'ll lay it out with you, free.</p></div>';
    var maxW = Math.min(520, (root.clientWidth || 600) - 120), maxH = 300;
    if (window.matchMedia && window.matchMedia('(min-width: 990px)').matches) maxW = Math.min(520, Math.max(320, root.clientWidth * 0.55 - 160));
    if (COMPACT) { maxW = Math.min(420, ((elSheet && elSheet.clientWidth) || 380) - 130); maxH = 220; }
    var OX = 40, OY = 30, sc = Math.min(Math.max(maxW, 180) / P.bw, maxH / P.bh, 24);
    var h = '', num = 0;
    function px(v) { return v.toFixed(1) + 'px'; }
    P.circles.forEach(function (c) {
      var size = 2 * c.R * sc, cellsHTML = '', fadedHTML = '', k = 0;
      var nums = c.cells.length <= 60 && c.cells[0] && c.cells[0].w * sc >= 26 && c.cells[0].h * sc >= 18;
      var tags = c.cells[0] && c.cells[0].w * sc >= 14 && c.cells[0].h * sc >= 12;
      c.cells.forEach(function (cl) {
        var lbl = '';
        if (cl.tag) lbl = tags && cl.w * sc >= 12 ? cl.tag : '';
        else if (!cl.cut) { k++; lbl = nums ? k : ''; }
        var box = '<div class="lhp-cells lhp-panel' + (cl.tag ? ' is-shared' : cl.cut ? ' is-cut' : '') + '" style="left:' + px(cl.x * sc) + ';top:' + px(cl.y * sc) + ';width:' + px(cl.w * sc) + ';height:' + px(cl.h * sc) + '">';
        // Letters sit in the middle of the part of the piece that is actually used.
        if (cl.tag && lbl) {
          // Nudge thin slivers inward so the letter isn't clipped by the circle.
          var gx = cl.x + cl.m.cx - c.R, gy = cl.y + cl.m.cy - c.R, gd = Math.sqrt(gx * gx + gy * gy) || 1, nud = Math.max(0, 6 - (c.R - gd) * sc);
          lbl = '<span class="lhp-tagl" style="left:' + px(cl.m.cx * sc - gx / gd * nud) + ';top:' + px(cl.m.cy * sc - gy / gd * nud) + '">' + lbl + '</span>';
        }
        cellsHTML += box + lbl + '</div>';
        fadedHTML += box + '</div>';
      });
      // Faded full panels show what gets trimmed off; the clipped copy shows the finished circle.
      h += '<div class="lhp-trimmed" style="left:' + px(OX) + ';top:' + px(OY) + ';width:' + px(size) + ';height:' + px(size) + '">' + fadedHTML + '</div>';
      h += '<div class="lhp-circle" style="left:' + px(OX) + ';top:' + px(OY) + ';width:' + px(size) + ';height:' + px(size) + '">' + cellsHTML + '</div>';
      if (c.B) {
        var off = c.B * sc;
        h += '<div class="lhp-pen-line" style="left:' + px(OX + off) + ';top:' + px(OY + off) + ';width:' + px(c.D * sc) + ';height:' + px(c.D * sc) + '"></div>';
        h += '<div class="lhp-label is-pill" style="left:' + px(OX + c.R * sc) + ';top:' + px(OY + off + 22) + '">Round pen ' + c.D + "', " + c.B + "' buffer</div>";
      }
    });
    var showNums = P.n <= 60;
    P.pieces.forEach(function (pc) {
      if (pc.r) {
        var r = pc.r, cols = r.fullW + (r.remainW > 0 ? 1 : 0), rows = r.fullL + (r.remainL > 0 ? 1 : 0), yy = 0;
        for (var row = 0; row < rows; row++) {
          var ch = (row === r.fullL && r.remainL > 0) ? r.remainL : r.pl, xx = 0;
          for (var col = 0; col < cols; col++) {
            var cw = (col === r.fullW && r.remainW > 0) ? r.remainW : r.pw;
            var cut = cw !== r.pw || ch !== r.pl;
            var label = '';
            if (!cut) { num++; if (showNums && r.pw * sc >= 26 && r.pl * sc >= 18) label = num; }
            h += '<div class="lhp-cells lhp-panel' + (cut ? ' is-cut' : '') + '" style="left:' + px(OX + (pc.x + xx) * sc) + ';top:' + px(OY + (pc.y + yy) * sc) + ';width:' + px(cw * sc) + ';height:' + px(ch * sc) + '">' + label + '</div>';
            xx += cw;
          }
          yy += ch;
        }
        h += '<div class="lhp-area" style="left:' + px(OX + pc.x * sc) + ';top:' + px(OY + pc.y * sc) + ';width:' + px(pc.w * sc) + ';height:' + px(pc.l * sc) + '"></div>';
      } else if (pc.cell) {
        var cc = pc.cell;
        h += '<div class="lhp-cells lhp-panel' + (cc.tag ? ' is-shared' : cc.cut ? ' is-cut' : '') + '" style="left:' + px(OX + cc.x * sc) + ';top:' + px(OY + cc.y * sc) + ';width:' + px(cc.w * sc) + ';height:' + px(cc.h * sc) + '">' +
          (cc.tag ? (cc.w * sc >= 12 && cc.h * sc >= 11 ? cc.tag : '') : (!cc.cut ? (++num, showNums && cc.w * sc >= 26 && cc.h * sc >= 18 ? num : '') : '')) + '</div>';
      } else if (pc.grid) {
        var g = pc.grid;
        for (var k = 0; k < g.rows; k++) {
          num++;
          h += '<div class="lhp-cells lhp-panel" style="left:' + px(OX + pc.x * sc) + ';top:' + px(OY + (pc.y + k * g.ph) * sc) + ';width:' + px(g.pw * sc) + ';height:' + px(g.ph * sc) + '">' + (showNums && g.pw * sc >= 26 && g.ph * sc >= 18 ? num : '') + '</div>';
        }
      }
    });
    var svg = '';
    if (P.polys.length) {
      svg = '<svg class="lhp-poly" aria-hidden="true">' + P.polys.map(function (pl) {
        return '<polygon points="' + pl.map(function (q) { return (OX + q[0] * sc).toFixed(1) + ',' + (OY + q[1] * sc).toFixed(1); }).join(' ') + '"/>';
      }).join('') + '</svg>';
    }
    P.labels.forEach(function (lb) {
      h += '<div class="lhp-label' + (lb.v ? ' is-v' : '') + (lb.pill ? ' is-pill' : '') + '" style="left:' + px(OX + lb.x * sc + (lb.dx || 0)) + ';top:' + px(OY + lb.y * sc + (lb.dy || 0)) + '">' + esc(lb.t) + '</div>';
    });
    var aria = 'Layout of ' + P.n + ' panels for ' + P.dims;
    return '<div class="lhp-draw" role="img" aria-label="' + esc(aria) + '" style="width:' + px(P.bw * sc + OX * 2) + ';height:' + px(P.bh * sc + OY + 30) + '">' + h + svg + '</div>';
  }

  var lastPlan = null, lastPrice = null;
  function sheetHTML() {
    var P = plan();
    lastPlan = P;
    var d = new Date();
    var today = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    var quoteNo = 'LH-' + String(d.getFullYear()).slice(2) + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('00' + P.n).slice(-3);
    var useLabel = '', title = '';
    USES.forEach(function (u) { if (u[0] === S.use) useLabel = u[1]; });
    title = (S.name.trim() || useLabel || 'Your mud-free area') + (P.valid ? ', ' + P.dims : '');
    var head = '<div class="lhp-sheet__head"><div><div class="lhp-brand">Lighthoof</div><div class="lhp-tag">MUD-FREE. FOREVER.</div></div>' +
      '<div class="lhp-meta"><div class="lhp-meta__title">PROJECT PLAN &amp; QUOTE</div><div>No. ' + quoteNo + '</div><div>Prepared ' + today + '</div></div></div>';
    if (!P.valid) {
      lastPrice = null;
      return head + '<div class="lhp-empty"><svg width="56" height="40" viewBox="0 0 56 40" fill="none" stroke="#b8963a" stroke-width="1.6" stroke-dasharray="4 3" aria-hidden="true"><rect x="2" y="2" width="52" height="36" rx="2"/></svg><p>Enter your measurements to see your layout, materials and price.</p></div>';
    }
    var pr = pricing(P.n, P.fabricArea);
    lastPrice = pr;
    var gPer = S.deep ? 2 : 1.5, gravel = P.n * gPer, tons = Math.round(gravel * 1.4);
    var cover = P.n * 72, extra = Math.round(cover - P.area);
    var fit = P.trimNote ? P.trimNote + (extra > 0 ? ' Plan on trimming about ' + fmt(extra) + ' sq ft.' : '') :
      (P.pieces.some(function (pc) { return pc.r && (pc.r.remainW > 0 || pc.r.remainL > 0); }) ? 'Striped pieces are cut from extra panels.' : 'Exact fit, no cutting.');
    var save = pr.regular - pr.total;
    var bestLabel, bestNote;
    if (pr.kind === 'bundle') { bestLabel = 'BEST PRICE: BUNDLE' + (pr.lines.length > 1 ? ' + EXTRAS' : ''); bestNote = 'Beats buying ' + P.n + ' panels and fabric separately by ' + money(pr.loose - pr.total) + '.'; }
    else if (B2B) { bestLabel = 'YOUR WHOLESALE TOTAL'; bestNote = 'Your wholesale price, the same at any quantity.'; }
    else { bestLabel = pr.unit.tier.discount > 0 ? 'VOLUME PRICING APPLIED' : 'YOUR TOTAL'; bestNote = P.n < 10 ? 'Add ' + (10 - P.n) + ' more panel' + (10 - P.n > 1 ? 's' : '') + ' to get 5% off every panel.' : 'Volume discount applies automatically at checkout.'; }
    var ship = P.n <= 12 ? ['UPS Ground', 'UPS Ground, ships in 2 to 3 business days'] : ['Freight', 'LTL freight on pallets, ships in 2 to 3 business days'];
    var h = head;
    h += '<div class="lhp-sheet__title"><div><div class="lhp-kicker">' + esc(useLabel ? useLabel.toUpperCase() : 'YOUR AREA') + '</div><h2>' + esc(title) + '</h2></div>' +
      '<div class="lhp-count"><div class="lhp-count__n">' + P.n + '</div><div>Lighthoof panel' + (P.n === 1 ? '' : 's') + '</div></div></div>';
    h += '<figure class="lhp-fig"><div class="lhp-paper">' + diagramHTML(P) + '</div>' +
      '<figcaption><span><i class="lhp-sw lhp-cells"></i>Panel, 6\' x 12\' (72 sq ft)</span>' +
      (P.pieces.some(function (pc) { return pc.r && (pc.r.remainW > 0 || pc.r.remainL > 0); }) ? '<span><i class="lhp-sw lhp-cells is-cut"></i>Cut piece</span>' : '') +
      (P.shared ? '<span><i class="lhp-sw lhp-cells is-shared"></i>' + (S.mode === 'trap' ? 'Top pieces' : 'Edge pieces') + ', same letter = cut from one panel</span>' : '') +
      (S.mode === 'trap' && !P.shared && P.pieces.some(function (pc) { return pc.cell && pc.cell.cut; }) ? '<span><i class="lhp-sw lhp-cells is-cut"></i>Cut piece</span>' : '') +
      '<span><i class="lhp-sw lhp-sw--area"></i>Your area</span><span class="lhp-fit">' + esc(fit) + '</span></figcaption></figure>';
    if (P.note) h += '<p class="lhp-note">' + esc(P.note) + '</p>';
    h += '<div class="lhp-stats">' +
      '<div><span>Area</span><strong>' + fmt(P.area) + ' sq ft</strong></div>' +
      '<div><span>Gravel to order locally</span><strong>' + fmt(gravel, 1) + ' cu yd</strong><em>about ' + fmt(tons) + ' tons</em></div>' +
      '<div><span>Ties included</span><strong>' + fmt(P.n * 40) + '</strong><em>40 per panel, free</em></div>' +
      '<div><span>Ships by</span><strong>' + ship[0] + '</strong><em>Free, from Houston, TX</em></div></div>';
    h += '<table class="lhp-lines"><caption>YOUR ORDER</caption><tbody>';
    pr.lines.forEach(function (ln) { h += '<tr><td><strong>' + esc(ln.name) + '</strong><small>' + esc(ln.detail) + '</small></td><td>' + money(ln.amt) + '</td></tr>'; });
    h += '<tr><td><strong>Shipping</strong><small>' + ship[1] + '</small></td><td class="lhp-free">FREE</td></tr></tbody></table>';
    h += '<div class="lhp-best"><div><div class="lhp-best__label">' + bestLabel + '</div><div class="lhp-best__note">' + esc(bestNote) + '</div></div>' +
      '<div class="lhp-best__price">' + (save > 0.5 ? '<div class="lhp-best__save"><s>' + money(pr.regular) + '</s> <span>You save ' + money(save) + '</span></div>' : '') + '<div class="lhp-best__total">' + money(pr.total) + '</div></div></div>';
    h += '<div class="lhp-foot"><span>Fill: 3/8" to 1/2" minus crushed rock with fines. Never pea gravel or sand.</span><span>No excavation or base layer needed.</span><span>Questions: ' + esc(PHONE) + ' · info@lighthoof.com</span><span class="lhp-print-only">Reopen this plan: lighthoof.com/pages/panel-calculator</span></div>';
    return h;
  }

  // Compact summary card: count, small drawing, price, gravel, and the two next steps.
  function fullPlanURL() { return FULL_URL + '#plan=' + encodeURIComponent(encodeState()); }
  function cartLabelFor(P, pr) {
    if (pr.kind === 'bundle') return 'Add the ' + pr.bundle.panels + '-panel bundle to cart';
    return 'Add ' + P.n + ' panel' + (P.n > 1 ? 's' : '') + (S.fabric ? ' + fabric' : '') + ' to cart';
  }
  function miniHTML() {
    var P = plan();
    lastPlan = P;
    if (!P.valid) {
      lastPrice = null;
      return '<div class="lhp-mini__empty"><svg width="56" height="40" viewBox="0 0 56 40" fill="none" stroke="#b8963a" stroke-width="1.6" stroke-dasharray="4 3" aria-hidden="true"><rect x="2" y="2" width="52" height="36" rx="2"/></svg>' +
        '<p><strong>Your panel count and price show up here.</strong>Enter your measurements to see your layout drawn to scale.</p></div>';
    }
    var pr = pricing(P.n, P.fabricArea);
    lastPrice = pr;
    var gravel = P.n * 1.5, save = pr.regular - pr.total;
    var priceLabel = pr.kind === 'bundle' ? pr.bundle.panels + '-panel bundle with fabric' :
      P.n + ' panel' + (P.n > 1 ? 's' : '') + (pr.fab ? ' + fabric' : '') + (B2B ? ', wholesale price' : '') + (pr.unit.tier.discount > 0 ? ', ' + Math.round(pr.unit.tier.discount * 100) + '% volume price' : '');
    var ship = P.n <= 12 ? 'UPS Ground' : 'freight';
    var h = '<div class="lhp-mini__head"><div><div class="lhp-kicker">YOUR PLAN</div><div class="lhp-mini__dims">' + esc(P.dims) + '</div></div>' +
      '<div class="lhp-count"><div class="lhp-count__n">' + P.n + '</div><div>Lighthoof panel' + (P.n === 1 ? '' : 's') + '</div></div></div>';
    h += '<figure class="lhp-fig"><div class="lhp-paper">' + diagramHTML(P) + '</div></figure>';
    h += '<div class="lhp-mini__price"><div><div class="lhp-best__label">YOUR PRICE</div><div class="lhp-best__note">' + esc(priceLabel) + '</div></div>' +
      '<div class="lhp-best__price">' + (save > 0.5 ? '<div class="lhp-best__save"><s>' + money(pr.regular) + '</s> <span>Save ' + money(save) + '</span></div>' : '') + '<div class="lhp-best__total">' + money(pr.total) + '</div></div></div>';
    h += '<ul class="lhp-mini__facts"><li>Free shipping by ' + ship + '</li><li>About ' + fmt(gravel, 1) + ' cu yd of gravel to order locally</li><li>' + fmt(P.n * 40) + ' ties included</li></ul>';
    h += '<div class="lhp-actions"><button type="button" class="lhp-btn lhp-btn--primary" data-cart="1"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 4h2l2.5 11h11L21 7H7"/><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/></svg><span>' + esc(cartLabelFor(P, pr)) + '</span></button></div>';
    h += '<p class="lhp-cart-msg" data-slot="cartmsg" role="status" hidden></p>';
    h += '<div data-slot="email">' + emailHTML() + '</div>';
    h += '<p class="lhp-mini__more"><a data-full="1" href="' + esc(fullPlanURL()) + '">See the full layout and cut list</a></p>';
    return h;
  }

  // "Email me this plan" box (GHL inbound webhook). Same box on the full page and in compact mode.
  function emailHTML() {
    var h = '';
    if (cfg.webhook) {
      if (!S.sent) {
        h += '<form class="lhp-email" data-email="1" novalidate><div class="lhp-email__title">Email me this plan, plus $40 off</div>' +
          '<p>We\'ll send your plan, a $40 coupon and a short install guide. Not ready yet? Your plan will be waiting.</p>' +
          '<div class="lhp-email__row"><label class="lhp-sr" for="lhp-fname">First name</label><input id="lhp-fname" type="text" name="first_name" autocomplete="given-name" placeholder="First name">' +
          '<label class="lhp-sr" for="lhp-email">Email address</label><input id="lhp-email" type="email" name="email" autocomplete="email" required placeholder="you@example.com">' +
          '<button type="submit" class="lhp-btn lhp-btn--dark">Send my plan</button></div>' +
          '<p class="lhp-email__fine">By sending, you agree to get emails from Lighthoof. Unsubscribe anytime.</p><p class="lhp-email__err" role="alert" hidden></p></form>';
      } else {
        h += '<div class="lhp-email lhp-email--done" role="status"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6d7c0e" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M7 12l3.5 3.5L17 9"/></svg><div><div class="lhp-email__title">Your plan is on its way</div><p>Check ' + esc(S.sentTo || 'your inbox') + ' for your plan and $40 code. Questions about your layout? Just reply to that email.</p></div></div>';
      }
    }
    return h;
  }

  function actionsHTML() {
    if (COMPACT) return '';
    var P = lastPlan, pr = lastPrice;
    if (!P || !P.valid || !pr) return '';
    var cartLabel;
    if (pr.kind === 'bundle') {
      var ex = P.n - pr.bundle.panels;
      cartLabel = 'Add the ' + pr.bundle.panels + '-panel bundle' + (ex > 0 ? ' + ' + ex + ' panel' + (ex > 1 ? 's' : '') : '') + ' to cart';
    } else cartLabel = 'Add ' + P.n + ' panel' + (P.n > 1 ? 's' : '') + (S.fabric ? ' + fabric' : '') + ' to cart';
    var h = '<div class="lhp-actions"><button type="button" class="lhp-btn lhp-btn--primary" data-cart="1"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 4h2l2.5 11h11L21 7H7"/><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/></svg><span>' + esc(cartLabel) + '</span></button>' +
      '<button type="button" class="lhp-btn lhp-btn--ghost" data-print="1"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 4v11M7 10l5 5 5-5M5 20h14"/></svg>Download PDF</button></div>';
    h += '<p class="lhp-cart-msg" data-slot="cartmsg" role="status" hidden></p>';
    h += emailHTML();
    return h;
  }

  // ---------- Mount ----------
  root.innerHTML = '<div class="lhp__grid' + (COMPACT ? ' is-compact' : '') + '"><div class="lhp__controls" data-slot="controls"></div>' +
    '<div class="lhp__result"><article class="lhp-sheet' + (COMPACT ? ' lhp-mini' : '') + '" data-slot="sheet" aria-live="polite"></article><div data-slot="actions"></div></div></div>';
  root.setAttribute('data-ready', 'true');
  var elControls = root.querySelector('[data-slot="controls"]');
  var elSheet = root.querySelector('[data-slot="sheet"]');
  var elActions = root.querySelector('[data-slot="actions"]');

  function renderControls() { elControls.innerHTML = controlsHTML(); }
  var completeKey = '';
  function renderResult() {
    // In compact mode, keep the summary card if someone is focused on its buttons.
    var act0 = document.activeElement;
    if (COMPACT && act0 && elSheet.contains(act0) && !(act0.closest && act0.closest('[data-slot="controls"]'))) { /* leave as is */ }
    else {
      // Keep anything already typed in the compact email box when the card redraws.
      var keep = {};
      ['lhp-fname', 'lhp-email'].forEach(function (id) { var el = COMPACT && document.getElementById(id); if (el && el.value) keep[id] = el.value; });
      elSheet.innerHTML = COMPACT ? miniHTML() : sheetHTML();
      for (var id in keep) { var el2 = document.getElementById(id); if (el2) el2.value = keep[id]; }
    }
    // keep the email box if someone is typing in it
    var active = document.activeElement;
    if (!(active && elActions.contains(active))) elActions.innerHTML = actionsHTML();
    var diag = elControls.querySelector('[data-slot="diag"]');
    if (diag) {
      if (lastPlan && lastPlan.diag) { diag.hidden = false; diag.innerHTML = 'Quick check: your angled side should measure about <strong>' + lastPlan.diag + ' ft</strong>. If it\'s way off, the corners may not be square. <a href="' + HELP_URL + '">Send us a photo</a> and we\'ll help.'; }
      else diag.hidden = true;
    }
    if (lastPlan && lastPlan.valid) {
      var key = S.mode + ':' + lastPlan.n + ':' + Math.round(lastPlan.area);
      if (key !== completeKey) {
        completeKey = key;
        clearTimeout(renderResult.t);
        renderResult.t = setTimeout(function () { track('calculator_complete', { panels_needed: lastPlan.n, total_sqft: Math.round(lastPlan.area), shape: S.mode }); }, 1200);
      }
    }
  }
  renderControls();
  renderResult();

  var interactT;
  root.addEventListener('input', function (e) {
    var t = e.target, sk = t.getAttribute('data-k') || '';
    var sm = /^s([wl])(\d)$/.exec(sk);
    if (sm) S.secs[+sm[2]][sm[1]] = t.value;
    else if (sk === 'name' || FIELDS.indexOf(sk) !== -1) S[sk] = t.value;
    if (t.closest('[data-slot="controls"]')) {
      renderResult();
      clearTimeout(interactT);
      interactT = setTimeout(function () { track('calculator_interaction', { calculator_field: sk || 'other', shape: S.mode }); }, 1000);
    }
  });
  root.addEventListener('change', function (e) {
    if (e.target.getAttribute('data-fabric')) { S.fabric = e.target.checked; renderResult(); }
  });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b || !root.contains(b)) return;
    if (b.hasAttribute('data-mode')) { S.mode = b.getAttribute('data-mode'); renderControls(); renderResult(); return; }
    if (b.hasAttribute('data-deep')) { S.deep = b.getAttribute('data-deep') === '1'; renderControls(); renderResult(); return; }
    if (b.hasAttribute('data-add')) { S.secs.push({ w: '', l: '' }); renderControls(); renderResult(); return; }
    if (b.hasAttribute('data-remove')) { S.secs.splice(+b.getAttribute('data-remove'), 1); renderControls(); renderResult(); return; }
    if (b.hasAttribute('data-print')) { track('calculator_pdf', { panels_needed: lastPlan ? lastPlan.n : 0 }); preparePrint(); window.print(); return; }
    if (b.hasAttribute('data-cart')) { addToCart(b); return; }
  });
  // Compact mode: the "full plan" link always carries the current measurements.
  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-full]');
    if (!a) return;
    a.href = fullPlanURL();
    track('calculator_cta_click', { cta_destination: FULL_URL, panels_needed: lastPlan ? lastPlan.n : 0 });
  });
  root.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-email]');
    if (!f) return;
    e.preventDefault();
    sendPlan(f);
  });

  // Popular project cards elsewhere on the page: <a data-lh-plan='{"mode":"rect","w":12,"l":24,"use":"shelter"}'>
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-lh-plan]') : null;
    if (!a) return;
    e.preventDefault();
    try {
      var o = JSON.parse(a.getAttribute('data-lh-plan'));
      S.mode = o.mode || 'rect'; S.use = o.use || ''; S.fabric = true; if (o.name) S.name = o.name;
      if (o.w) S.w = String(o.w); if (o.l) S.l = String(o.l);
      renderControls(); renderResult();
      track('calculator_interaction', { calculator_field: 'popular_project', shape: S.mode });
      document.getElementById('lh-plan').scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (err) {}
  });

  // ---------- Cart ----------
  function addToCart(btn) {
    var pr = lastPrice;
    if (!pr) return;
    var items = pr.cart.filter(function (c) { return c[0] && c[1] > 0; }).map(function (c) { return { id: c[0], quantity: c[1] }; });
    var msg = root.querySelector('[data-slot="cartmsg"]');
    track('calculator_cta_click', { cta_destination: '/cart', panels_needed: lastPlan.n });
    if (!items.length) { window.location.href = PANEL_URL; return; }
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () {
        btn.disabled = false;
        if (msg) { msg.hidden = false; msg.innerHTML = 'Something went wrong adding that to your cart. <a href="' + esc(PANEL_URL) + '">Shop panels here</a> or call ' + esc(PHONE) + '.'; }
      });
  }

  // ---------- Email this plan (GHL inbound webhook) ----------
  function planSummary() {
    var P = lastPlan, pr = lastPrice, lines = [];
    if (PLACEMENT !== 'calculator_page') lines.push('From: ' + (PLACEMENT === 'homepage' ? 'homepage' : PLACEMENT + ' page') + ' planner');
    lines.push((S.name.trim() || 'Lighthoof plan') + ': ' + P.dims);
    lines.push(P.n + ' panels, ' + fmt(P.area) + ' sq ft');
    pr.lines.forEach(function (l) { lines.push(l.name + ' (' + l.detail + '): ' + money(l.amt)); });
    lines.push('Total: ' + money(pr.total) + ', free shipping');
    lines.push('Gravel: ' + fmt(P.n * (S.deep ? 2 : 1.5), 1) + ' cu yd of 3/8" to 1/2" minus crushed rock with fines');
    return lines.join('\n');
  }
  // One plain line that says what they'd buy, for the plan email.
  function orderLine(pr, P) {
    if (pr.kind === 'bundle') return pr.bundle.panels + '-panel bundle with fabric included';
    return P.n + ' panel' + (P.n > 1 ? 's' : '') + (pr.fab ? ' + geotextile fabric (' + pr.fab.desc + ')' : '') + ', ' + pr.unit.tier.label.toLowerCase();
  }
  function sendPlan(f) {
    var email = f.querySelector('input[name="email"]').value.trim();
    var first = f.querySelector('input[name="first_name"]').value.trim();
    var err = f.querySelector('.lhp-email__err');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.hidden = false; err.textContent = 'Please enter a valid email address.'; return; }
    err.hidden = true;
    var P = lastPlan, pr = lastPrice, link = location.origin + (COMPACT ? FULL_URL : location.pathname) + '#plan=' + encodeURIComponent(encodeState());
    var useLabel = '';
    USES.forEach(function (u) { if (u[0] === S.use) useLabel = u[1]; });
    var data = {
      email: email, first_name: first, source: 'Lighthoof panel planner',
      project_name: S.name.trim(), project_use: useLabel, shape: S.mode, dimensions: P.dims,
      panels: P.n, area_sqft: Math.round(P.area), gravel_cu_yd: fmt(P.n * (S.deep ? 2 : 1.5), 1),
      fabric: S.fabric ? 'yes' : 'no', quote_total: money(pr.total), quote_value: (Math.round(pr.total * 100) / 100).toFixed(2), quote_type: pr.kind === 'bundle' ? pr.bundle.panels + '-panel bundle' : 'loose panels',
      plan_summary: planSummary(), plan_link: link, page_url: location.href.split('#')[0],
      plan_title: (S.name.trim() ? S.name.trim() + ', ' : '') + P.dims,
      plan_area: fmt(P.area) + ' sq ft', plan_gravel: fmt(P.n * (S.deep ? 2 : 1.5), 1) + ' cu yd',
      plan_order: orderLine(pr, P), plan_total: money(pr.total), planner_placement: PLACEMENT
    };
    var btn = f.querySelector('button[type="submit"]');
    btn.disabled = true; btn.textContent = 'Sending...';
    var body = new URLSearchParams();
    for (var k in data) body.append(k, data[k]);
    fetch(cfg.webhook, { method: 'POST', mode: 'no-cors', body: body })
      .then(function () {
        S.sent = true; S.sentTo = email;
        if (COMPACT) { var slot = elSheet.querySelector('[data-slot="email"]'); if (slot) slot.innerHTML = emailHTML(); }
        else elActions.innerHTML = actionsHTML();
        track('calculator_plan_emailed', { panels_needed: P.n });
      })
      .catch(function () {
        btn.disabled = false; btn.textContent = 'Send my plan';
        err.hidden = false; err.textContent = 'That didn\'t go through. Please try again, or call ' + PHONE + '.';
      });
  }

  // Redraw the diagram at the new width when the window changes size.
  var rz;
  window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(renderResult, 200); });
  // Only the full planner takes over printing. Elsewhere the page prints normally.
  if (!COMPACT) window.addEventListener('beforeprint', function () {
    if (lastPlan && lastPlan.valid) history.replaceState(null, '', '#plan=' + encodeURIComponent(encodeState()));
    preparePrint();
  });

  // ---------- Print / PDF ----------
  // The page prints only a copy of the plan sheet, placed straight under <body>, so nothing else on the
  // page can add blank pages. It is scaled to fit one letter page inside half-inch margins.
  function preparePrint() {
    document.documentElement.classList.add('lhp-printing');
    if (!document.getElementById('lhp-page-style')) {
      var ps = document.createElement('style'); ps.id = 'lhp-page-style';
      ps.textContent = '@media print { @page { size: letter; margin: 0; } }';
      document.head.appendChild(ps);
    }
    var box = document.getElementById('lhp-print');
    if (!box) { box = document.createElement('div'); box.id = 'lhp-print'; box.className = 'lhp'; document.body.appendChild(box); }
    box.innerHTML = '<article class="lhp-sheet">' + elSheet.innerHTML + '</article>';
    var sheet = box.firstChild;
    box.style.zoom = '';
    box.classList.add('is-measuring');
    var h = sheet.scrollHeight, maxH = 9.6 * 96;
    box.classList.remove('is-measuring');
    var z = h > maxH ? Math.max(0.55, Math.floor(maxH / h * 100) / 100) : 1;
    sheet.style.zoom = z < 1 ? String(z) : '';
  }
})();
